// DoctorInfoModal.js
import React from 'react';
import './DoctorInfoModal.css'; // Import the CSS file

const DoctorInfoModal = ({ infoImagePath, doctorName, doctorInfo, languageCodes }) => {

  const backgroundImageStyle = {
    backgroundImage: `url(${infoImagePath})`
  };

    // Function to render flag images based on language codes
    const renderFlags = () => {
      return languageCodes.map(code => (
        <img 
          key={code} 
          className="flag" 
          src={`https://www.ovumia.fi/wp-content/themes/ovumia/images/flags/${code}.png`} 
          width="24" 
          height="24" 
          alt={code.toUpperCase()} 
        />
      ));
    };

  return (
    <div className='doctor-info-item'>
      <div className='doctor-info-content'>
        <a>
          <div className='doctor-img' style={backgroundImageStyle}>

          </div>
          <p className='doctor-name'>
            {doctorName}
          </p>
        </a>
        <p className='doctor-details'>
          {doctorInfo}
        </p>
        <p>
          {renderFlags()}
        </p>
      </div>
    </div>
  );
};

export default DoctorInfoModal;



